function getRegularHourFormat(hour) {
  let regularHourFormat;
  let meridian;
  if (hour === 0) {
    regularHourFormat = 12;
  } else if (hour > 12) {
    regularHourFormat = hour - 12;
  } else {
    regularHourFormat = hour;
  }
  if (hour >= 12 && hour < 24) {
    meridian = 'PM';
  } else {
    meridian = 'AM';
  }
  return regularHourFormat + meridian;
}

export default getRegularHourFormat;
